import { render, staticRenderFns } from "./IconDownloadPdf.vue?vue&type=template&id=155d947c"
import script from "./IconDownloadPdf.vue?vue&type=script&lang=js"
export * from "./IconDownloadPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155d947c')) {
      api.createRecord('155d947c', component.options)
    } else {
      api.reload('155d947c', component.options)
    }
    module.hot.accept("./IconDownloadPdf.vue?vue&type=template&id=155d947c", function () {
      api.rerender('155d947c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/table/IconDownloadPdf.vue"
export default component.exports